/* tslint:disable */
/* eslint-disable */
/**
 * Bookings API
 * Bookings API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetLocations200ResponseInner
 */
export interface GetLocations200ResponseInner {
    /**
     * 
     * @type {string}
     * @memberof GetLocations200ResponseInner
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof GetLocations200ResponseInner
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof GetLocations200ResponseInner
     */
    address: string;
    /**
     * 
     * @type {string}
     * @memberof GetLocations200ResponseInner
     */
    phoneNumber: string;
}

/**
 * Check if a given object implements the GetLocations200ResponseInner interface.
 */
export function instanceOfGetLocations200ResponseInner(value: object): value is GetLocations200ResponseInner {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('address' in value) || value['address'] === undefined) return false;
    if (!('phoneNumber' in value) || value['phoneNumber'] === undefined) return false;
    return true;
}

export function GetLocations200ResponseInnerFromJSON(json: any): GetLocations200ResponseInner {
    return GetLocations200ResponseInnerFromJSONTyped(json, false);
}

export function GetLocations200ResponseInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetLocations200ResponseInner {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'address': json['address'],
        'phoneNumber': json['phoneNumber'],
    };
}

export function GetLocations200ResponseInnerToJSON(json: any): GetLocations200ResponseInner {
    return GetLocations200ResponseInnerToJSONTyped(json, false);
}

export function GetLocations200ResponseInnerToJSONTyped(value?: GetLocations200ResponseInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'address': value['address'],
        'phoneNumber': value['phoneNumber'],
    };
}

